import icProgramStage from "@/assets/images/user/icProgramStage.svg";
import programStage2026Cont1Img1 from "@/assets/images/user/programStage2026Cont1Img1.jpg";
import programStage2026Cont2Img1 from "@/assets/images/user/programStage2026Cont2Img1.jpg";
import programStage2026Cont2Img2 from "@/assets/images/user/programStage2026Cont2Img2.jpg";
// import programStage2026Cont2Img3 from "@/assets/images/user/programStage2026Cont2Img3.png";
import programStage2026Cont2Img3 from "@/assets/images/user/programStage2026Cont2Img3.jpg";
import programStage2026Cont3Img1 from "@/assets/images/user/programStage2026Cont3Img1.jpg";
import programStage2026Cont3Img2 from "@/assets/images/user/programStage2026Cont3Img2.jpg";
import programStage2026Cont3Img3 from "@/assets/images/user/programStage2026Cont3Img3.jpg";
import programStage2026Cont3Img4 from "@/assets/images/user/programStage2026Cont3Img4.jpg";
import programStage2026Cont3Img5 from "@/assets/images/user/programStage2026Cont3Img5.jpg";
import programStage2026Cont3Img6 from "@/assets/images/user/programStage2026Cont3Img6.jpg";
// SOUND TRACK 포스터. 원본이 표시 영역과 같은 3:2 가로형이라 별도 합성 없이 그대로 쓴다.
// 1191x794 = 표시 크기 420x280 의 약 2.84배수(고DPR 대응).
import soundTrackPoster from "@/assets/images/user/programStage2026Cont3Poster.png";
import programStage2026Cont4Img1 from "@/assets/images/user/programStage2026Cont4Img1.jpg";
import programStage2026Cont4Img2 from "@/assets/images/user/programStage2026Cont4Img2.jpg";
import programStage2026Cont4Img3 from "@/assets/images/user/programStage2026Cont4Img3.jpg";
import programStage2026Cont4Img4 from "@/assets/images/user/programStage2026Cont4Img4.jpg";
import programStage2026Cont4Img5 from "@/assets/images/user/programStage2026Cont4Img5.jpg";
import programStage2026Cont5Img1 from "@/assets/images/user/programStage2026Cont5Img1.jpg";
import programStage2026Cont6Img1 from "@/assets/images/user/programStage2026Cont6Img1.jpg";
import programStage2026Cont6Img2 from "@/assets/images/user/programStage2026Cont6Img2.jpg";
import programStage2026Cont6Img3 from "@/assets/images/user/programStage2026Cont6Img3.jpg";
import programStage2026Cont6Img4 from "@/assets/images/user/programStage2026Cont6Img4.jpg";
import programStage2026Cont7Img1 from "@/assets/images/user/programStage2026Cont7Img1.jpg";
import programStage2026Cont7Img2 from "@/assets/images/user/programStage2026Cont7Img2.jpg";
import programStage2026Cont7Img3 from "@/assets/images/user/programStage2026Cont7Img3.jpg";
import programStage2026Cont7Img4 from "@/assets/images/user/programStage2026Cont7Img4.png";
import programStage2026Cont7Img5 from "@/assets/images/user/programStage2026Cont7Img5.png";
import programStage2026Cont7Img6 from "@/assets/images/user/programStage2026Cont7Img6.png";
// import programStageCont1Img1 from "@/assets/images/user/programStageCont1Img1.jpg";
// import programStageCont2Img1 from "@/assets/images/user/programStageCont2Img1.jpg";
// import programStageCont2Img2 from "@/assets/images/user/programStageCont2Img2.jpg";
// import programStageCont2Img3 from "@/assets/images/user/programStageCont2Img3.jpg";
// import programStageCont3Img1 from "@/assets/images/user/programStageCont3Img1.jpg";
// import programStageCont3Img2 from "@/assets/images/user/programStageCont3Img2.jpg";
// import programStageCont3Img3 from "@/assets/images/user/programStageCont3Img3.jpg";
// import programStageCont3Img4 from "@/assets/images/user/programStageCont3Img4.jpg";
// import programStageCont3Img5 from "@/assets/images/user/programStageCont3Img5.jpg";
// import programStageCont3Img6 from "@/assets/images/user/programStageCont3Img6.jpg";
// import programStageCont3Img7 from "@/assets/images/user/programStageCont3Img7.jpg";
// import programStageCont4Img1 from "@/assets/images/user/programStageCont4Img1.jpg";
// import programStageCont4Img2 from "@/assets/images/user/programStageCont4Img2.jpg";
// import programStageCont4Img3 from "@/assets/images/user/programStageCont4Img3.jpg";
// import programStageCont4Img4 from "@/assets/images/user/programStageCont4Img4.jpg";
// import programStageCont4Img5 from "@/assets/images/user/programStageCont4Img5.jpg";
// import programStageCont4Img6 from "@/assets/images/user/programStageCont4Img6.jpg";
// import programStageCont4Img7 from "@/assets/images/user/programStageCont4Img7.jpg";
// import programStageCont5Img1 from "@/assets/images/user/programStageCont5Img1.jpg";
// import programStageCont5Img2 from "@/assets/images/user/programStageCont5Img2.jpg";
// import programStageCont6Img1 from "@/assets/images/user/programStageCont6Img1.jpg";
// import programStageCont6Img2 from "@/assets/images/user/programStageCont6Img2.jpg";
// import programStageCont6Img3 from "@/assets/images/user/programStageCont6Img3.jpg";
import programStageCont7Day1Img1 from "@/assets/images/user/programStageCont7Day1Img1.jpg";
import programStageCont7Day1Img2 from "@/assets/images/user/programStageCont7Day1Img2.jpg";
import programStageCont7Day1Img3 from "@/assets/images/user/programStageCont7Day1Img3.jpg";
import programStageCont7Day1Img4 from "@/assets/images/user/programStageCont7Day1Img4.jpg";
import programStageCont7Day1Img5 from "@/assets/images/user/programStageCont7Day1Img5.jpg";
import programStageCont7Day1Img6 from "@/assets/images/user/programStageCont7Day1Img6.jpg";
import programStageCont7Day1Img7 from "@/assets/images/user/programStageCont7Day1Img7.jpg";
import programStageCont7Day2Img1 from "@/assets/images/user/programStageCont7Day2Img1.jpg";
import programStageCont7Day2Img2 from "@/assets/images/user/programStageCont7Day2Img2.jpg";
import programStageCont7Day2Img3 from "@/assets/images/user/programStageCont7Day2Img3.jpg";
import programStageCont7Day2Img4 from "@/assets/images/user/programStageCont7Day2Img4.jpg";
import programStageCont7Day2Img5 from "@/assets/images/user/programStageCont7Day2Img5.jpg";
import programStageCont7Day2Img6 from "@/assets/images/user/programStageCont7Day2Img6.jpg";
import programStageCont7Day2Img7 from "@/assets/images/user/programStageCont7Day2Img7.jpg";
import programStageCont7Day2Img8 from "@/assets/images/user/programStageCont7Day2Img8.jpg";
import programStageCont7Day2Img9 from "@/assets/images/user/programStageCont7Day2Img9.jpg";
import programStageCont7Img1 from "@/assets/images/user/programStageCont7Img1.jpg";
import programStageCont8Img1 from "@/assets/images/user/programStageCont8Img1.jpg";
// import programStageCont8Img2 from "@/assets/images/user/programStageCont8Img2.jpg";
// import programStageCont8Img3 from "@/assets/images/user/programStageCont8Img3.jpg";
// import programStageTimeTable from "@/assets/images/user/programStageTimeTable.jpg";
// import programStageTimeTableTb from "@/assets/images/user/programStageTimeTableTb.jpg";
import CaptionImg from "@/components/user/common/CaptionImg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";
import SubTitle from "@/components/user/common/SubTitle";
// import ImgZoomPop from "@/components/user/popup/ImgZoomPop";

const txtBoxClass =
    "max-w-[72px] w-full text-[16px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[10px]";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// const txtGradientClass = "bg-gradient-to-r from-[#DE548E] to-[#C63270] bg-clip-text text-transparent";
const txtGradientClass2 = "bg-gradient-to-r from-[#FF5B2E] to-[#FF7F71] bg-clip-text text-transparent";
// 시안 tit 중 폭이 내용에 맞춰 늘어나는 가변형 라벨 (일시/장소처럼 72·120 고정이 아님)
const titBoxClass =
    "w-fit max-w-full text-[16px] px-[12px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:px-[20px] md:text-[20px] md:py-[10px]";
// 시안: 출연 그룹 제목(인디 아이돌 쇼케이스 등)은 박스 없이 검정 굵은 텍스트
const stageGroupTitClass = "font-['GongGothicMedium'] text-[20px] text-black md:text-[28px]";
// 코스프레 댄스 하위 라벨. 상위 라벨(출연)의 박스형과 뎁스가 섞이지 않도록 박스 없이 계열색 텍스트로만 둔다.
const subGroupTitClass = "font-['GongGothicMedium'] text-[18px] leading-[28px] md:text-[22px] md:leading-[32px]";
// 코스프레 댄스 하위 목록. dot 은 한 줄에 하나만 두고 항목은 콤마로 잇는다. dot 색은 SOUND TRACK 카드 라벨과 동일(#FF5B2E).
const dotItemClass =
    "relative pl-[16px] font-['GongGothicLight'] text-[16px] leading-[26px] text-black before:absolute before:left-0 before:top-[9px] before:size-[8px] before:rounded-full before:bg-[#FF5B2E] before:content-[''] md:pl-[20px] md:text-[18px] md:leading-[32px] md:before:top-[12px]";
// 참가무대 카드 캡션 (시안: THE STAGE 그라디언트)
const txtGradientStageClass = "bg-gradient-to-r from-[#E9492A] to-[#FF7F71] bg-clip-text text-transparent";
// 일시의 Day 1 / Day 2 / PRE-EVENT 라벨 강조 (시안: GongGothicBold + #FF5B2E, 뒤따르는 ": 날짜 시간" 은 Light/black)
const dayLabelClass = "font-['GongGothicBold'] text-[#FF5B2E]";

// The 3rd GXG SOUND TRACK 본선 진출팀
const soundTrackTeams = [
    { name: "NOX", img: programStage2026Cont3Img1, motive: "P의 거짓: 서곡", song: "Bite the lie" },
    { name: "Catalog", img: programStage2026Cont3Img2, motive: "메이플스토리", song: "매화" },
    { name: "하현", img: programStage2026Cont3Img3, motive: "블루 아카이브", song: "LoveRace" },
    { name: "현악밴드 모마드", img: programStage2026Cont3Img4, motive: "PUBG: 배틀그라운드", song: "Nova X" },
    { name: "언리얼 오디세이", img: programStage2026Cont3Img5, motive: "던전앤파이터 유니버스", song: "Gloria" },
    { name: "Solaris", img: programStage2026Cont3Img6, motive: "리그 오브 레전드", song: "Arise!" },
];

// SOUND TRACK 카드 안 항목 라벨(모티브/곡명). 앞의 dot 은 팀명과 같은 계열색(#FF5B2E).
// 글자 크기 전환점은 버스킹 타임 카드와 동일하게 sm.
// 폭은 시안 100px 대신 92px. 카드가 가장 좁아지는 구간(md~lg 2단)에서 100px 이면
// 최장값 "PUBG: 배틀그라운드"(18px 기준 137.3px)가 값 영역을 넘겨 두 줄로 깨지고
// 그 카드만 높아져 같은 줄 다른 카드 아래에 빈 공간이 생긴다. 92px 이면 전 구간 한 줄 유지.
const soundTrackLabelClass =
    "relative w-[72px] shrink-0 pl-[16px] font-['GongGothicMedium'] text-[16px] after:absolute after:left-0 after:top-[8px] after:size-[8px] after:rounded-full after:bg-[#FF5B2E] after:content-[''] sm:w-[92px] sm:pl-[20px] sm:text-[20px] sm:after:top-[11px]";

// 한국 서브컬처 공모전 코스프레 댄스 결선 진출팀 (꺾쇠 포함 원문 표기라 JSX 대신 문자열로 둔다)
const cosplayFinalists = [
    "<길티 봉인해제의 키스>",
    "<영원히, 달링>",
    "<메루>",
    "<반>",
    "<길티하게 개과천선>",
];

const programList = [
    {
        title: "사전 공연",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            <span className={dayLabelClass}>Day 1</span> 9.11 (금) 17:30 ~ 18:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            판교역 중앙광장 - 메인 무대
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            {/* GXG 2025의 시작을 알리는 <br className="md:hidden" />
                            사전 축하 공연 <br />제 1회 게임음악경연대회 우승팀 밴드 리프 (Lif)의 공연을 즐겨보세요! */}
                            GXG 2026의 <br className="block sm:hidden" /> 첫 무대를 장식하는 공연!
                            <br />
                            The 2nd GXG SOUND TRACK <br className="block sm:hidden" />
                            우승팀 우주골치클럽의 <br />
                            강렬한 사운드와 폭발적인 에너지로 <br className="block sm:hidden" /> GXG 2026의 시작을
                            함께하세요!
                        </p>
                    </li>
                </ul>
                <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                    <img src={programStage2026Cont1Img1} alt="우주골치클럽" className="w-full" />
                </div>
            </div>
        ),
    },
    {
        title: <p className="flex">GXG 2026 개막선언 & 축하공연</p>,

        // title: "[The Stage] GXG 2026 개막선언 & 축하공연",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        <span className={dayLabelClass}>Day 1</span> 9.11 (금) 18:00 ~ 19:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        판교역 중앙광장 - 메인 무대
                    </p>
                </li>
                <li className="flex items-start gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>내용</p>
                    {/* <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        GXG 2025의 시작을 알리는 <br className="md:hidden" />
                        개막 세리머니와 함께 <br />
                        대한민국 대표 디바, 에일리의 <br className="md:hidden" />
                        파워풀한 축하 공연이 펼쳐집니다.
                    </p> */}
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        GXG 2026의 시작을 알리는 개막 <br className="block sm:hidden" /> 세리머니와 함께{" "}
                        <br className="hidden sm:block" />
                        대한민국 힙합을 <br className="block sm:hidden" />
                        대표하는 다이나믹 듀오의 폭발적인 <br className="block sm:hidden" />
                        에너지와 압도적인 무대가 펼쳐집니다.
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>MC</p>
                    <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                        김규환 캐스터, 최시은 아나운서
                    </p>
                </li>
                <li>
                    {/* MC 사진 2장. sm 미만에서는 2열, sm 이상에서는 3열 기준 폭(1/3)을 유지한다. */}
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] sm:w-[calc(33.333%-5.333px)] md:w-[calc(33.333%-13.333px)]">
                            <img src={programStage2026Cont2Img1} alt="김규환 캐스터" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] sm:w-[calc(33.333%-5.333px)] md:w-[calc(33.333%-13.333px)]">
                            <img src={programStage2026Cont2Img2} alt="최시은 아나운서" className="w-full" />
                        </li>
                    </ul>
                </li>
                {/* 축하공연은 라벨이 사진 왼쪽이 아니라 위에 붙는다. */}
                <li className="flex flex-col items-start gap-[16px] md:gap-[20px]">
                    <p className={txtBoxClass}>축하공연</p>
                    {/* 모바일은 전체 폭, sm 이상은 MC 사진과 같은 3열 기준 폭 */}
                    <div className="w-full sm:w-[calc(33.333%-5.333px)] md:w-[calc(33.333%-13.333px)]">
                        <img src={programStage2026Cont2Img3} alt="다이나믹 듀오" className="w-full" />
                    </div>
                </li>
            </ul>
        ),
    },
    {
        title: (
            <p>
                The 3<span className="align-super text-[0.7em]">rd</span> <br className="block sm:hidden" />
                GXG SOUND TRACK
            </p>
        ),
        // title: (
        //     <p className="flex">
        //         The 2<span className="font-['GongGothicLight'] text-[12px] md:text-[18px]">nd&nbsp;</span>GXG SOUND
        //         TRACK
        //     </p>
        // ),
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:gap-[24px]">
                {/* 시안: 일시·장소·내용 묶음 오른쪽에 포스터가 붙는다(xl 이상). */}
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                <span className={dayLabelClass}>Day 1</span> 9.11 (금) 19:00 ~ 21:30
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교역 중앙광장 - 메인 무대
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            {/* <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                게임을 모티브로 한 창작곡을 <br className="md:hidden" />
                                감상하고, 현장 투표에도 <br className="md:hidden" />
                                직접 참여해 보세요. <br />
                                본선에 오른 7팀의 멋진 무대가 <br className="md:hidden" />
                                시작됩니다.
                            </p> */}
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                최종 본선에 오른 창작자들의
                                <br className="block sm:hidden" /> 치열한 라이브 무대!
                                <br />
                                관객과 함께 최고의 게임 음악을
                                <br className="block sm:hidden" /> 완성하는 순간을 함께하세요.
                            </p>
                        </li>
                    </ul>
                    {/* 이미지 자체가 시안의 420x280 비율로 합성돼 있어 영역을 그대로 채운다. */}
                    <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                        <img
                            src={soundTrackPoster}
                            alt="GXG SOUND TRACK 포스터"
                            className="aspect-[420/280] w-full object-contain"
                        />
                    </div>
                </div>
                <ul className="flex flex-col gap-[16px] md:flex-row md:flex-wrap md:gap-[20px]">
                    {soundTrackTeams.map((team, i) => (
                        <li
                            key={`soundTrack_${i}`}
                            className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]"
                        >
                            {/* 이미지 파일에 1px #DDD 테두리가 포함돼 있어 CSS border 를 주지 않는다(주면 2겹). */}
                            <img src={team.img} alt={team.name} className="aspect-square w-full object-cover" />
                            {/* 시안: 테두리는 이미지에만 있고 하단 정보 패널에는 없다(버스킹 카드와 다른 점). */}
                            <div className="flex flex-1 flex-col gap-[24px] bg-[#F1F4F9] p-[16px_12px] sm:p-[20px]">
                                <p
                                    className={`text-center font-['GongGothicMedium'] text-[18px] sm:text-[24px] ${txtGradientClass2}`}
                                >
                                    {team.name}
                                </p>
                                <ul className="flex flex-col gap-[8px] sm:gap-[16px]">
                                    <li className="flex items-start gap-[8px] leading-[26px] sm:leading-[32px]">
                                        <p className={soundTrackLabelClass}>모티브</p>
                                        <p className="flex-1 font-['GongGothicLight'] text-[16px] sm:text-[18px]">
                                            {team.motive}
                                        </p>
                                    </li>
                                    {/* 시안 하단 여백은 패딩 20px + 11px = 31px */}
                                    <li className="flex items-start gap-[8px] leading-[26px] sm:mb-[11px] sm:leading-[32px]">
                                        <p className={soundTrackLabelClass}>곡명</p>
                                        <p className="flex-1 font-['GongGothicLight'] text-[16px] sm:text-[18px]">
                                            {team.song}
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    ))}
                </ul>
                {/* <ul className="flex flex-col gap-[16px] md:flex-row md:flex-wrap md:gap-[20px]">
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img1} alt="이미지" className="w-full" />
                            <div className="flex flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p className={`text-[20px] ${txtGradientClass} md:text-[24px]`}>
                                    <span className="font-['GongGothicMedium']">ON:</span>
                                    <span className="font-[500]">明</span>
                                </p>
                                <p className="text-[18px] md:text-[20px]">
                                    <span className="font-['GongGothicLight']">여명:</span>
                                    <span className="font-[300]">&nbsp;舁明&nbsp;</span>- 검은사막
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img2} alt="이미지" className="w-full" />
                            <div className="flex flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                >
                                    겜블러
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    잭팟! - 모바일 한게임 포커
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img3} alt="이미지" className="w-full" />
                            <div className="flex flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                >
                                    볼따구프렌즈
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    Be fine! - 트릭컬 리바이브
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img4} alt="이미지" className="w-full" />
                            <div className="flex flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                >
                                    EZ DO BAND
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    Sync or Sink - 리그오브레전드
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img5} alt="이미지" className="w-full" />
                            <div className="flex flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                >
                                    버닝
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    두고 봐 빛날거야 - 메이플스토리
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img6} alt="이미지" className="w-full" />
                            <div className="flex flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                >
                                    Band 203
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">Up! - 브롤스타즈</p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont3Img7} alt="이미지" className="w-full" />
                            <div className="flex flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                >
                                    우주골치클럽
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    Hollow`s puppet - P의 거짓
                                </p>
                            </div>
                        </li>
                    </ul> */}
            </div>
        ),
    },
    {
        title: <p className="flex">일러스타 페스 스테이지</p>,
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                <span className={dayLabelClass}>Day 2</span> 9.12 (토) 12:00 ~ 15:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교역 중앙광장 - 메인 무대
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            {/* <p className="md:text-[18p x] flex-1 font-['GongGothicLight'] text-[16px] text-black">
                                서브컬처의 트렌드를 이끄는 <br className="md:hidden" />
                                인디 아이돌의 공연부터 <br />
                                눈길을 사로잡는 코스튬 플레이어의 <br className="md:hidden" />
                                무대까지! <br />
                                일러스타 페스의 열기를 <br className="md:hidden" />
                                GXG 2025에서 느껴보세요.
                            </p> */}
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                서브컬처의 트렌드를 이끄는 <br className="block sm:hidden" />
                                한국 서브컬처 공모전 코스프레 댄스 <br className="block sm:hidden" />
                                부문 시상에서부터 <br className="hidden sm:block" />
                                인디 아이돌 쇼케이스와 <br className="block sm:hidden" />
                                아티스트 꽃감이의 게임 뮤직 LIVE 까지! <br />
                                일러스타 페스의 열기를 <br className="block sm:hidden" />
                                GXG 2026에서 느껴보세요.
                                {/* 서브 컬처 팬이라면
                                <br className="block sm:hidden" /> 놓칠 수 없는 일러스타 페스의{" "}
                                <br className="block sm:hidden" />
                                특별한 무대 프로그램! <br />
                                자세한 프로그램은 8월 공개됩니다. */}
                            </p>
                        </li>
                    </ul>
                    {/* 교체된 원본에는 캡션이 없어, 시안대로 하단 그라디언트 + 제목을 코드로 얹는다(1.5배수 소스) */}
                    <CaptionImg
                        src={programStage2026Cont4Img1}
                        caption="일러스타 페스 스테이지"
                        className="w-full border border-[#DDD] sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0"
                    />
                </div>
                <p className={titBoxClass}>출연</p>
                {/* 시안: 카드 없이 제목만 있는 그룹. 바깥 래퍼의 40px 간격을 그대로 쓴다. */}
                <div className="flex flex-col gap-[16px] md:gap-[20px]">
                    <p className={stageGroupTitClass}>한국 서브컬처 공모전 코스프레 댄스</p>
                    {/* 하위 라벨은 박스 없이 계열색 텍스트만 써서 상위 박스 라벨과 뎁스를 구분한다. */}
                    <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                        <li className="flex flex-col items-start gap-[4px] md:gap-[8px]">
                            <p className={`${subGroupTitClass} ${txtGradientClass2}`}>오프닝 특별 공연</p>
                            <p className={dotItemClass}>{"<호랑 x 사자보이즈 진우>"}</p>
                        </li>
                        <li className="flex flex-col items-start gap-[4px] md:gap-[8px]">
                            <p className={`${subGroupTitClass} ${txtGradientClass2}`}>결선 진출팀</p>
                            {/* 팀명 중간에서 줄이 끊기지 않도록 항목마다 nowrap. 항목 사이 공백에서만 줄바꿈된다. */}
                            <p className={dotItemClass}>
                                {cosplayFinalists.map((team, i) => (
                                    <span key={`cosplayFinalist_${i}`}>
                                        {i > 0 && " "}
                                        <span className="whitespace-nowrap">
                                            {team}
                                            {i < cosplayFinalists.length - 1 && ","}
                                        </span>
                                    </span>
                                ))}
                            </p>
                        </li>
                    </ul>
                </div>
                {/* 카드: 모바일 1열(전체 폭) / md 이상 3열(간격 30) */}
                <div className="flex flex-col gap-[16px] md:gap-[20px]">
                    <p className={stageGroupTitClass}>인디 아이돌 쇼케이스</p>
                    <ul className="flex flex-col gap-[16px] md:flex-row md:flex-wrap md:gap-[30px]">
                        <li className="w-full md:w-[calc(33.333%-20px)]">
                            <div className="border border-[#DDD]">
                                <img src={programStage2026Cont4Img2} alt="뮤로" className="block w-full" />
                            </div>
                            <div className="bg-[#F1F4F9] p-[20px] text-center">
                                <p
                                    className={`font-['GongGothicMedium'] text-[18px] leading-[32px] md:text-[24px] ${txtGradientStageClass}`}
                                >
                                    뮤로
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(33.333%-20px)]">
                            <div className="border border-[#DDD]">
                                <img src={programStage2026Cont4Img3} alt="아이돌 콜렉션" className="block w-full" />
                            </div>
                            <div className="bg-[#F1F4F9] p-[20px] text-center">
                                <p
                                    className={`font-['GongGothicMedium'] text-[18px] leading-[32px] md:text-[24px] ${txtGradientStageClass}`}
                                >
                                    아이돌 콜렉션
                                </p>
                            </div>
                        </li>
                        <li className="w-full md:w-[calc(33.333%-20px)]">
                            <div className="border border-[#DDD]">
                                <img src={programStage2026Cont4Img4} alt="요이쇼이" className="block w-full" />
                            </div>
                            <div className="bg-[#F1F4F9] p-[20px] text-center">
                                <p
                                    className={`font-['GongGothicMedium'] text-[18px] leading-[32px] md:text-[24px] ${txtGradientStageClass}`}
                                >
                                    요이쇼이
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-[16px] md:gap-[20px]">
                    <p className={stageGroupTitClass}>꽃감이의 게임 뮤직 LIVE</p>
                    <ul className="flex flex-col gap-[16px] md:flex-row md:flex-wrap md:gap-[30px]">
                        <li className="w-full md:w-[calc(33.333%-20px)]">
                            <div className="border border-[#DDD]">
                                <img src={programStage2026Cont4Img5} alt="아티스트 꽃감이" className="block w-full" />
                            </div>
                            <div className="bg-[#F1F4F9] p-[20px] text-center">
                                <p
                                    className={`font-['GongGothicMedium'] text-[18px] leading-[32px] md:text-[24px] ${txtGradientStageClass}`}
                                >
                                    아티스트 꽃감이
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                {/* <ul>
                    <li className="flex flex-col gap-[20px]">
                        <p className={txtBoxClass}>출연</p>
                        <div className="flex flex-col gap-[8px]">
                            <p className="font-['GongGothicMedium'] text-[20px] md:text-[24px]">코스플레이</p>
                            <p className="font-['GongGothicLight'] text-[16px] md:text-[18px]">
                                점프는 기세야!, 무테키노아이도루, 와쿠와쿠 로드, 보카로 사이에 피어난 루카, 미쿠&렌
                                스트릿, 댄스댄스비배스
                            </p>
                        </div>
                        <p className="font-['GongGothicMedium'] text-[20px] md:text-[24px]">인디아이돌</p>
                        <ul className="flex flex-col gap-[16px] md:flex-row md:flex-wrap md:gap-[20px]">
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img2} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        Memoria
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img3} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        IDOL COLLECTION
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img4} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        우고프페
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img5} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        H7KD
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img6} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        REKIREM
                                    </p>
                                </div>
                            </li>
                            <li className="w-full md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont4Img7} alt="이미지" className="w-full" />
                                <div className="bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                    <p
                                        className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass}`}
                                    >
                                        IHOTEU
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul> */}
            </div>
        ),
    },
    {
        title: <p className="flex">AI GSDC 시상식</p>,
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            <span className={dayLabelClass}>Day 2</span> 9.12 (토) 15:30 ~ 16:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            판교역 중앙광장 - 메인 무대
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            AI Game Sound Design <br className="block sm:hidden" /> Challenge 시상식
                            <br />
                            AI와 창작이 만나 탄생한 새로운 <br className="block sm:hidden" />
                            게임 사운드!
                            <br />
                            혁신적인 아이디어와 뛰어난 <br className="block sm:hidden" />
                            작품을 선보인 수상자들을 축하하는 <br className="block sm:hidden" />
                            특별한 시간을 함께합니다.
                        </p>
                    </li>
                </ul>
                <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                    <img src={programStage2026Cont5Img1} alt="AI GSDC" className="w-full" />
                </div>
            </div>
        ),
    },
    {
        title: <p className="flex">GXG 갈라 콘서트</p>,
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[24px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                <span className={dayLabelClass}>Day 2</span> 9.12 (토) 17:00 ~ 21:30
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교역 중앙광장 - 메인 무대
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            {/* <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            세대를 초월한 콘솔 게임 명작 대전, <br />
                            승리의 영광과 함께 경품을 <br className="md:hidden" />
                            차지하세요!
                        </p> */}
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                GXG 2026의 피날레를 장식할 <br className="sm:hidden" />
                                특별한 갈라 콘서트!
                                <br />
                                게임 속 명장면과 감정을 담아낸 <br className="sm:hidden" />
                                다채로운 게임음악이 <br className="hidden sm:block" />
                                가을밤을 <br className="sm:hidden" />
                                수놓으며 깊은 감동과 여운을 선사합니다.
                                <br />
                                자세한 프로그램은 8월 공개됩니다.
                            </p>
                        </li>
                        {/* 2025 MC 영역 (2026 시안에는 갈라 콘서트에 MC 없음)
                    <li className="flex flex-col gap-[16px] md:gap-[40px]">
                        <div className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>MC</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                김규환 캐스터, 최시은 아나운서
                            </p>
                        </div>
                        <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                            <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont5Img1} alt="이미지" className="w-full" />
                            </li>
                            <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programStageCont5Img2} alt="이미지" className="w-full" />
                            </li>
                        </ul>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>참여</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            9월 20일 현장 신청자 중 추첨을 통해 선정된 관람객 <br />
                            - 이벤트 등록 신청은 GXG 2025 중앙광장 인포메이션 부스 <br className="md:hidden" />
                            9/20(토) 13:00 ~ 14:30 운영 예정 <br />
                            - 신청자 중 현장 추첨을 통해 GXG 플레이 타임 참여 인원이 선발됩니다. <br />
                            *SNS를 통해 현장 신청 안내 예정이며, 현장 상황에 따라 변동될 수 있음
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>종목</p>
                        <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                            - 오버 쿡드2 (2인 팀전) <br />- 철권 8 *만 15세 이상부터 출전 가능합니다.
                        </p>
                    </li> */}
                        {/* xl 미만에서는 시안 흐름대로 내용 바로 뒤에 대표 이미지가 온다.
                            xl 에서는 우측 열로 빠지므로 아래 중복 노드를 쓰고 여기서는 숨긴다(같은 src 라 요청은 1회). */}
                        <li className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:hidden">
                            <img src={programStage2026Cont6Img1} alt="GXG 갈라 콘서트" className="w-full" />
                        </li>
                        <li className="flex items-start gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>출연</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                네오플 장애인 첼로 연주단 <br className="block sm:hidden" />
                                앙상블 힐(Ensemble Heal) <br />
                                국립국악원 창작악단 게임 사운드 시리즈 <br />
                                GXG SOUND TRACK 본선 진출팀
                            </p>
                        </li>
                    </ul>
                    {/* 캡션(GXG 갈라 콘서트)과 하단 그라디언트가 이미지에 포함된 1.5배수 소스 */}
                    <div className="hidden xl:block xl:w-[420px] xl:shrink-0">
                        <img src={programStage2026Cont6Img1} alt="GXG 갈라 콘서트" className="w-full" />
                    </div>
                </div>
                {/* 출연진 이미지 3장. 캡션이 이미지에 포함된 1.5배수 소스 */}
                <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                    <li className="w-full sm:w-[calc(33.333%-5.333px)] md:w-[calc(33.333%-13.333px)]">
                        <img src={programStage2026Cont6Img2} alt="앙상블 힐" className="w-full" />
                    </li>
                    <li className="w-full sm:w-[calc(33.333%-5.333px)] md:w-[calc(33.333%-13.333px)]">
                        <img src={programStage2026Cont6Img3} alt="국립국악원 창작악단" className="w-full" />
                    </li>
                    <li className="w-full sm:w-[calc(33.333%-5.333px)] md:w-[calc(33.333%-13.333px)]">
                        <img src={programStage2026Cont6Img4} alt="본선 진출팀" className="w-full" />
                    </li>
                </ul>
            </div>
        ),
    },
];

// STREET STAGE 참가 밴드
const streetStageBands = [
    {
        name: "0810",
        img: programStage2026Cont7Img2,
        desc: (
            <>
                아침 8시부터 10시까지 <br />
                합주하고 출근하는 <br />
                컴투스 직장인 밴드!
            </>
        ),
    },
    {
        name: "GO밴드",
        img: programStage2026Cont7Img3,
        desc: (
            <>
                음악으로 하나 되어 <br />
                함께 나아가는 <br />
                스마일게이트 직장인 밴드 <br />
                GoBand
            </>
        ),
    },
    {
        name: "Mrs.아오링고",
        img: programStage2026Cont7Img4,
        desc: (
            <>
                미세스 그린애플이 좋아서 <br />
                모인 데브캣 소속 커버 밴드 <br />
                Mrs.아오링고
            </>
        ),
    },
    {
        name: "NMIN",
        img: programStage2026Cont7Img5,
        desc: (
            <>
                No Microphone <br />
                Instrumental Nerds, <br />
                게임·IT 직장인 밴드
            </>
        ),
    },
    {
        name: "만취더락",
        img: programStage2026Cont7Img6,
        desc: (
            <>
                낮에는 게임을, <br />
                밤에는 음악을 만드는 <br />
                넥슨 밴드 만취더락
            </>
        ),
    },
];

// STREET STAGE 섹션 (판교 콘텐츠 거리)
const programList3 = [
    {
        title: <p className="flex">GXG 버스킹 타임</p>,
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[24px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-[24px]">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                <span className={dayLabelClass}>PRE-EVENT</span> 9.10 (목) 17:00 ~ 21:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교 콘텐츠 거리
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교 게임업계 종사자들로 구성된 <br className="block md:hidden" /> 직장인 밴드 <br />
                                각양각색 직장인 밴드의 <br className="block md:hidden" /> 라이브 버스킹을 놓치지 마세요!
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>출연</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                0810, GO밴드, Mrs.아오링고, NMIN, 만취더락
                            </p>
                        </li>
                    </ul>
                    <div className="w-full sm:w-[calc(50%-10px)] sm:max-w-[420px] xl:w-[420px] xl:shrink-0">
                        <img src={programStage2026Cont7Img1} alt="스트릿 스테이지" className="w-full" />
                    </div>
                </div>
                <ul className="flex flex-col gap-[16px] md:flex-row md:flex-wrap md:gap-[20px]">
                    {streetStageBands.map(band => (
                        <li
                            key={band.name}
                            className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(20%-16px)]"
                        >
                            <img
                                src={band.img}
                                alt={band.name}
                                className="aspect-square w-full border border-[#DDD] object-cover xl:aspect-auto xl:h-[240px]"
                            />
                            <div className="flex flex-1 flex-col gap-[8px] border border-t-0 border-[#DDD] bg-[#F1F4F9] p-[16px_12px] text-center md:p-[20px_12px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[18px] sm:text-[24px] ${txtGradientClass2}`}
                                >
                                    {band.name}
                                </p>
                                <p className="font-['GongGothicLight'] text-[16px] sm:text-[20px]">{band.desc}</p>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        ),
    },
];

// SUB STAGE 섹션 임시 비활성화로 현재 미사용 (JSX 재활성화 시 disable 주석 제거)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const programList2 = [
    {
        title: "GXG 버스킹 타임 - 직장인 밴드",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[20px] md:gap-[40px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                <span className={dayLabelClass}>Day 1</span> : 9.19 (금) 16:00 ~ 21:00 <br />
                                <span className={dayLabelClass}>Day 2</span> : 9.20 (토) 16:00 ~ 21:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교역 북측광장 B - 서브 스테이지
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                GXG 2025를 더 특별하게 즐기는 <br className="md:hidden" />
                                방법! <br />
                                각양각색 직장인 밴드의 <br className="md:hidden" />
                                라이브 버스킹을 놓치지 마세요.
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                            <p className={txtBoxClass}>9.19 (금)</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                인헤븐리, 서큐버스, <br className="md:hidden" />
                                만화영화주제가밴드, 국키스텐, <br className="md:hidden" />
                                ADO X CAVO, <br className="xl:hidden" />
                                전원참석, GO-Band
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                            <p className={txtBoxClass}>9.20 (토)</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                사우스캐슬, 대환장 밴드, M8, <br className="md:hidden" />
                                컴투스 밴드, 지수와로그, ED12, T.O.N.E, 인데놀 168, AOB
                            </p>
                        </li>
                    </ul>
                    <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                        <img src={programStageCont7Img1} alt="이미지" className="w-full" />
                    </div>
                </div>
                <div className="flex flex-col gap-[20px]">
                    <p className="font-['GongGothicMedium'] text-[18px] md:text-[28px]">DAY 1</p>
                    <ul className="flex flex-col gap-[16px] md:flex-row md:flex-wrap md:gap-[20px]">
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day1Img1} alt="이미지" className="w-full" />
                            <div className="flex-1 gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    인헤븐리
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    팬심으로 모인 다섯, <br />
                                    GXG에서 열정 폭발! <br />
                                    즐거운 무대 보여드리겠습니다!
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day1Img2} alt="이미지" className="w-full" />
                            <div className="flex-1 gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    서큐버스
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    롹과 팝을 넘나들며 에너지 넘치는 무대를 선사해드리도록 하겠습니다.
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day1Img3} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    만화영화주제가밴드
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    그 시절 우리가 사랑했던 것들로 <br />
                                    당신의 내일을 응원합니다.
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day1Img4} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    국키스텐
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    j-pop, 국내 인디를 좋아하는 <br />
                                    스마일게이트 밴드
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day1Img5} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    ADO X CAVO
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    개성 넘치는 일본 J-POP 가수 <br />
                                    Ado 의 곡을 커버하는 밴드입니다!
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day1Img6} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    전원참석
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    다 모이고 싶지만 쉽지 않은 <br />
                                    직장인 밴드 &#39;전원참석&#39;입니다.
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day1Img7} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    Go-Band
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    하나 되어 전하는 음악, Go-Band!
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
                <div className="flex flex-col gap-[20px]">
                    <p className="font-['GongGothicMedium'] text-[18px] md:text-[28px]">DAY 2</p>
                    <ul className="flex flex-col gap-[16px] md:flex-row md:flex-wrap md:gap-[20px]">
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day2Img1} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    사우스캐슬
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    성남시청 직장인 밴드 <br />
                                    사우스 캐슬입니다
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day2Img2} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    대환장 밴드
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    어쩌다 보니 이렇게 되었습니다. <br />
                                    대환장 밴드
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day2Img3} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    M8
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    Mate의 M에 영원의 8을 더한 <br />
                                    M8입니다. 재밌게 놉시다.
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day2Img4} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    컴투스 밴드
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    컴투스 사내 밴드 <br />
                                    동호회에서 왔습니다.
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day2Img5} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    지수와로그
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    한로로라는 가수의 노래를 <br />
                                    커버하는 밴드입니다.
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day2Img6} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    ED12
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    안 해본 게 없다. 이제 <br />
                                    밴드만 남았다. ED12 Forever
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day2Img7} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    T.O.N.E
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    판교 게임업계 소속 <br />
                                    직장인 밴드입니다.
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day2Img8} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    인데놀 168
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    감각적인 사운드로 무대를 <br />
                                    채우는 INDENOL 168입니다.
                                </p>
                            </div>
                        </li>
                        <li className="flex w-full flex-col md:w-[calc(50%-10px)] xl:w-[calc(25%-15px)]">
                            <img src={programStageCont7Day2Img9} alt="이미지" className="w-full" />
                            <div className="flex flex-1 flex-col gap-[8px] bg-[#F1F4F9] p-[20px] text-center md:p-[20px_10px]">
                                <p
                                    className={`font-['GongGothicMedium'] text-[20px] md:text-[24px] ${txtGradientClass2}`}
                                >
                                    AOB
                                </p>
                                <p className="font-['GongGothicLight'] text-[18px] md:text-[20px]">
                                    익숙함, 그 너머의 색다름을 <br />
                                    추구하는 NC 최장수 밴드입니다.
                                </p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        ),
    },
    {
        title: "GXG 버스킹 타임 - 일러스타 페스",
        background: "bg-program202501",
        img: icProgramStage,
        contents: (
            <div className="flex flex-col gap-[16px] md:gap-[40px]">
                <div className="flex flex-col gap-[16px] md:gap-[40px] xl:flex-row xl:gap-0">
                    <ul className="flex flex-col gap-[16px] md:gap-[24px] xl:flex-1">
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>일시</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                <span className={dayLabelClass}>Day 1</span> : 9.19 (금) 14:00 ~ 15:00 <br />
                                <span className={dayLabelClass}>Day 2</span> : 9.20 (토) 15:30 ~ 16:00
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>장소</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                판교역 북측광장 B - 서브 스테이지
                            </p>
                        </li>
                        <li className="flex items-start gap-[8px] md:items-center md:gap-[20px]">
                            <p className={txtBoxClass}>내용</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                서브컬처 트렌드의 중심, <br className="md:hidden" />
                                일러스타 페스의 디제잉과 랜덤플레이 댄스가 함께하는 <br />
                                미니 프로그램을 즐겨보세요!
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>9.19 (금)</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                일러스타 DJ 커넥트 쁘띠 - 라티
                            </p>
                        </li>
                        <li className="flex items-center gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>9.20 (토)</p>
                            <p className="flex-1 font-['GongGothicLight'] text-[16px] text-black md:text-[18px]">
                                일러스아 DJ 커넥트 쁘띠 - Kizan
                            </p>
                        </li>
                    </ul>
                    <div className="w-full md:w-[calc(50%-10px)] xl:w-1/3">
                        <img src={programStageCont8Img1} alt="이미지" className="w-full" />
                    </div>
                </div>
                {/* <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                    <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                        <img src={programStageCont8Img2} alt="이미지" className="w-full" />
                    </li>
                    <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                        <img src={programStageCont8Img3} alt="이미지" className="w-full" />
                    </li>
                </ul> */}
            </div>
        ),
    },
];

export default function Stage() {
    return (
        <>
            {/* <div className="flex flex-col gap-[12px] p-[48px_0_20px] md:gap-[16px] xl:flex-row xl:items-center xl:justify-between xl:pt-[60px]">
                <SubTitle title="TIME TABLE" />
                <p className="font-['GongGothicLight'] text-[12px] md:text-[18px] xl:text-[24px]">
                    * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
                </p>
            </div>
            <div className="hidden xl:block">
                <img src={programStageTimeTable} alt="이미지" />
            </div>
            <div className="xl:hidden">
                <ImgZoomPop img={programStageTimeTableTb} />
            </div> */}
            <div className="flex flex-col gap-[12px] p-[48px_0_20px] md:gap-[16px] xl:flex-row xl:items-center xl:justify-between xl:pt-[60px]">
                <SubTitle title="STREET STAGE" />
                <p className="font-['GongGothicLight'] text-[12px] md:text-[18px] xl:text-[24px]">
                    * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
                </p>
            </div>
            <ProgramAccordion
                list={programList3}
                design="2026"
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
                hideItemBorder
            />
            <div className="flex flex-col gap-[12px] p-[48px_0_20px] md:gap-[16px] xl:flex-row xl:items-center xl:justify-between xl:pt-[60px]">
                <SubTitle title="MAIN STAGE" />
                <p className="font-['GongGothicLight'] text-[12px] md:text-[18px] xl:text-[24px]">
                    * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
                </p>
            </div>
            <ProgramAccordion
                list={programList}
                design="2026"
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
                hideItemBorder
            />
            {/* <div className="flex flex-col gap-[12px] p-[48px_0_20px] md:gap-[16px] xl:flex-row xl:items-center xl:justify-between xl:pt-[60px]">
                <SubTitle title="SUB STAGE" />
                <p className="font-['GongGothicLight'] text-[12px] md:text-[18px] xl:text-[24px]">
                    * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
                </p>
            </div>
            <ProgramAccordion
                list={programList2}
                design="2026"
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
            /> */}
        </>
    );
}
